export default __webpack_public_path__ + "static/berna-toprak-32c48cefbfbe4b3861ad0658a7a70da8.png";